/* v13: basket upgrade offer + guarantee line */
(function () {
  var drawer = document.querySelector('[data-ws-drawer]');
  if (!drawer) return;
  var b = document.querySelector('[data-ws-bundles]'), bundles = [];
  try { bundles = JSON.parse(b.textContent); } catch (e) {}
  var box = drawer.querySelector('[data-ws-up]');
  function money(c) { return '£' + (c / 100).toFixed(2); }
  function thr() {
    var e = document.querySelector('[data-ws-threshold]'); if (!e) return 0;
    var n = parseFloat(String(e.getAttribute('data-ws-threshold')).replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : Math.round(n * 100);
  }
  /* guarantee under checkout */
  var gd = document.querySelector('[data-ws-gdays]'), g = gd ? parseInt(gd.getAttribute('data-ws-gdays'), 10) : 0;
  var foot = drawer.querySelector('.ws-drawer__foot');
  if (foot && g > 0 && !foot.querySelector('.ws-dg')) {
    var p = document.createElement('p'); p.className = 'ws-dg';
    p.innerHTML = '<svg width="18" height="18" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 3.5l10 4v7.5c0 6.5-4.3 11-10 13.5C10.3 26 6 21.5 6 15V7.5z"/><path d="M11.5 15.5l3.2 3.2 6-6.2"/></svg><span><strong>' + g + '-day money-back guarantee.</strong> Not for you? Full refund, no need to send it back.</span>';
    var co = foot.querySelector('.ws-xco') || foot.querySelector('[data-ws-checkout]'); if (co) co.insertAdjacentElement('afterend', p);
  }
  function paint(cart) {
    if (!box || bundles.length < 2) return;
    var line = null, cur = null;
    cart.items.forEach(function (it) { bundles.forEach(function (v) { if (v.id === it.variant_id && it.quantity === 1 && !it.selling_plan_allocation && !line) { line = it; cur = v; } }); });
    var next = cur ? bundles.filter(function (v) { return v.qty === cur.qty + 1; })[0] : null;
    var hasBigger = cart.items.some(function (it) { return bundles.some(function (v) { return v.id === it.variant_id && v.qty > (cur ? cur.qty : 0); }); });
    if (!line || !next || hasBigger) { box.hidden = true; box.innerHTML = ''; return; }
    var extra = next.price - cur.price, save = bundles[0].price * next.qty - next.price;
    var t = thr(), freeNow = t > 0 && cart.total_price >= t, freeAfter = t > 0 && cart.total_price + extra >= t;
    var why = next.qty === 2 ? 'One for home, one for your bag.' : 'Buy 2, get 1 free.';
    box.innerHTML = '<img src="' + next.img + '" alt="" width="56" height="56">' +
      '<div class="ws-upg__t"><strong>Make it ' + next.qty + ' bottles</strong><span>' + why + ' Save ' + money(save) + (freeAfter && !freeNow ? ', and get free UK delivery' : '') + '.</span></div>' +
      '<button type="button" class="ws-upg__btn" data-ws-up-go>+' + money(extra) + '</button>';
    box.hidden = false;
    box.querySelector('[data-ws-up-go]').onclick = function () {
      var btn = this; btn.disabled = true; btn.textContent = 'Adding…';
      var u = {}; u[cur.id] = 0; u[next.id] = 1;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: u }) })
        .then(function (r) { return r.json(); })
        .then(function () { var o = document.querySelector('[data-ws-cart-open]'); if (o) o.click(); else location.reload(); })
        .catch(function () { location.href = '/cart'; });
    };
  }
  function refresh() { fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(paint).catch(function () {}); }
  var lines = drawer.querySelector('[data-ws-lines]');
  if (lines) new MutationObserver(refresh).observe(lines, { childList: true });
})();
